import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-property-list',
  templateUrl: './user-property-list.component.html',
  styleUrls: ['./user-property-list.component.css']
})
export class UserPropertyListComponent implements OnInit {
  env = environment;

  ulb_id: any = '';
  ulb_data: any = [];
  property_list: any = [];
  user_details: any = [];
  user_dtl: any = [];
  name = '';
  email = '';
  mobile_no = '';
  isMessageShow = false;


  constructor(private apiService : ApiService, 
    private appComponent: AppComponent, private router: Router) { }

  ngOnInit(): void {
    // this.getUlbDataList();
    this.getSearviceNumberList();
    if(this.env.environmentName = "srinagar"){
        this.ulb_id = this.env.ulb_id;
    }

    this.user_details = localStorage.getItem("loginDetails");
    if(this.user_details == null){
      this.router.navigate(['/login'], { queryParams: { returnUrl: '/user-property-list' }});
    }
    this.user_dtl = JSON.parse(this.user_details).user[0];
    this.name= this.user_dtl.name;
    this.email= this.user_dtl.email;
    this.mobile_no= this.user_dtl.mobile_no;

  }

  // getUlbDataList(){
  //   this.apiService.getCitizenData(`public_ulbs`).subscribe((res) =>{
  //     this.ulb_data = res.data;
  //   },
  //   (error) => {
  //     this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
  //   })
  // }

  getSearviceNumberList(){
    this.appComponent.showLoader();
    this.apiService.getCitizenData(`properties`).subscribe(
      (res:any) =>{
      this.property_list = res['data'];
      this.appComponent.hideLoader();
    },
    (error) => {
      this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      this.appComponent.hideLoader();
    })
  }

  logout(){
    this.appComponent.logout();
  }
  

}
